import "./index.css";
import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import { PrimeReactProvider , } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
// css utility

import 'boxicons/css/boxicons.min.css';
// my code for theme


import { createStore } from 'redux'

import { Provider } from 'react-redux'

import rootReducer from './redux/reducers'

// import 'primereact/resources/primereact.css';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './flags.css';
// import './index.css';
 import './Assest/css/Index.css';
 import './Assest/css/theme.css';
 import './Assest/css/modern-branding.css'; // Modern Branding Override
import App from './App';
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const store = createStore(
  rootReducer
)

msalInstance.initialize().then(async () => {
  // Handle redirect promise for any potential redirect flows
  await msalInstance.handleRedirectPromise().then((tokenResponse) => {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    const accounts = msalInstance.getAllAccounts();
    if (tokenResponse?.account) {
       msalInstance.setActiveAccount(tokenResponse.account);
    } else if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }
  }).catch((error) => console.error(error));

  msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
          const account = event.payload.account;
          msalInstance.setActiveAccount(account);
      }
  });

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
    <React.StrictMode>
      <PrimeReactProvider>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </PrimeReactProvider>
    </React.StrictMode>
    </Provider>,
  );
});


reportWebVitals();
